import React from 'react';
import AboutHero from '../components/common/AboutHero';
import Recete3 from '../assets/images/recete3.jpg';
import GenelCerrahi from '../assets/images/departman/genel-cerrahi.jpg';
import Kardiyoloji from '../assets/images/departman/kardiyoloji.jpg';
import CocukSagligi from '../assets/images/departman/cocuk.jpg';
import DepartmentShowcase, { DepartmentItem } from '../components/layout/DepartmentsShowcase';
import { toUrl } from '../lib/config';

const TibbiBirimlerPage: React.FC = () => {
  const DEFAULT_HERO = {
    kicker: '',
    title: 'Tıbbi Birimler',
    description:
      'Hastanemiz, geniş bir yelpazede tıbbi birimler sunar. Dahiliye, cerrahi, pediatri, kadın doğum, kardiyoloji, göz, kulak-burun-boğaz, radyoloji, onkoloji ve daha fazlasında uzmanlaşmış ekiplerimiz, hastalarımıza en iyi sağlık hizmetini sunmayı taahhüt eder. Gelişmiş teknoloji ve deneyimli doktorlarımızla hastalarımızın ihtiyaçlarını karşılarız.',
  };
  const [heroKicker, setHeroKicker] = React.useState<string>('');
  const [heroTitle, setHeroTitle] = React.useState<string>('');
  const [heroDesc, setHeroDesc] = React.useState<string>('');
  const DEFAULT_DEPARTMENTS: DepartmentItem[] = [
    {
      title: "Genel Cerrahi",
      paragraphs: [
        "Genel cerrahi, vücudun çeşitli bölgelerindeki cerrahi müdahaleleri gerçekleştiren bir tıp dalıdır. Karın bölgesindeki organlardan, meme, deri ve tiroit gibi yüzeysel bölgelere kadar birçok alanda cerrahi işlemler uygulanabilir. Genel cerrahi uzmanlarımız, hastaların durumu doğrultusunda ameliyatlar yaparak, hem tedavi sürecini hızlandırır hem de komplikasyonları önler. Ameliyat öncesi, sırası ve sonrasındaki her aşama dikkatle planlanarak, hastalar için en iyi sonuçlar elde edilmeye çalışılır.",
        "Bu alandaki cerrahi tedaviler, sadece fiziksel hastalıklarla sınırlı kalmaz, aynı zamanda hastaların psikolojik durumları da göz önünde bulundurularak yapılır. Uzman cerrahlarımız, hastalarla sürekli iletişim halinde olarak, onları tedavi sürecinin her aşamasında bilgilendirir ve rahatlatırlar. Hastaların iyileşme sürecine katkıda bulunan beslenme ve rehabilitasyon önerileri de bu bölümün önemli bir parçasıdır.",
        "Genel cerrahi, vücudun çeşitli bölgelerindeki cerrahi müdahaleleri gerçekleştiren bir tıp dalıdır. Karın bölgesindeki organlardan, meme, deri ve tiroit gibi yüzeysel bölgelere kadar birçok alanda cerrahi işlemler uygulanabilir. Genel cerrahi uzmanlarımız, hastaların durumu doğrultusunda ameliyatlar yaparak, hem tedavi sürecini hızlandırır hem de komplikasyonları önler. Ameliyat öncesi, sırası ve sonrasındaki her aşama dikkatle planlanarak, hastalar için en iyi sonuçlar elde edilmeye çalışılır.",
      ],
      image: GenelCerrahi,
      // cta: { label: "Daha Fazla", href: "/bolumler/genel-cerrahi" },
    },
    {
      title: "Kardiyoloji",
      paragraphs: [
        "Kardiyoloji, kalp ve dolaşım sistemi hastalıklarının tanı ve tedavisiyle ilgilenen bir tıp dalıdır. Kalp hastalıkları, dünya genelinde en yaygın sağlık sorunlarından biri olduğundan, bu alanda uzmanlık gerektiren teşhis ve tedavi yöntemleri oldukça önemlidir. Kardiyoloji bölümümüzde, kalp krizi, hipertansiyon, damar tıkanıklıkları, kalp ritim bozuklukları ve kalp yetmezliği gibi hastalıkların teşhisi ve tedavisi konusunda uzman bir kadro görev yapmaktadır. Modern teknoloji ile donatılmış tanı araçları sayesinde, hastaların sağlık durumları titizlikle değerlendirilmektedir.",
        "Kardiyoloji uzmanlarımız, hastalara düzenli kontroller, yaşam tarzı değişiklikleri ve medikal tedavi seçenekleri sunarak kalp sağlığını korumayı hedefler. Ayrıca, anjiyografi, stent uygulamaları, balon tedavileri gibi girişimsel kardiyoloji işlemleri de bölümümüzde başarıyla uygulanmaktadır. Kalp sağlığının korunması ve hastalıkların önlenmesi için erken teşhis büyük önem taşımakta, bu nedenle düzenli kardiyolojik kontroller"
      ],
      image: Kardiyoloji,
      // cta: { label: "Daha Fazla", href: "/bolum/kardiyoloji" },
    },
    {
      title: "Çocuk Sağlığı ve Hastalıkları",
      paragraphs: [
        "Çocuk sağlığı ve hastalıkları bölümü, çocukların doğumdan itibaren izlenmesi ve tedavi edilmesi gereken birçok hastalığı kapsar. Bebeklik, çocukluk ve ergenlik dönemindeki gelişimsel sorunlar, enfeksiyon hastalıkları ve aşı takibi gibi hizmetler bu bölüm tarafından sağlanır. Çocuk sağlığı uzmanlarımız, her çocuğun fiziksel ve duygusal gelişimini yakından izler ve erken teşhis için gereken tüm testleri uygular.",
        "Çocuk hastalıklarının tedavisi, yalnızca fiziksel belirtileri ortadan kaldırmakla kalmaz, aynı zamanda çocuğun genel sağlık durumunu iyileştirmek için de önemlidir. Aileler, çocuklarının sağlık durumu hakkında sürekli bilgilendirilir ve sağlıkla ilgili öneriler alırlar. Aile merkezli yaklaşımımız, çocukların tedavi sürecinde daha rahat olmalarını sağlar. Bu sayede tedavi sürecinin her aşamasında çocukların sağlığı güvence altına alınır.",
      ],
      image: CocukSagligi,
      // cta: { label: "Daha Fazla", href: "/bolum/cocuk-sagligi" },
    },

  ];
  const [departments, setDepartments] = React.useState(DEFAULT_DEPARTMENTS);

  React.useEffect(() => {
    let cancelled = false;
    const chooseImage = (title: string): string => {
      const t = (title || '').toLowerCase();
      const match = DEFAULT_DEPARTMENTS.find(d => d.title.toLowerCase() === t);
      if (match) return match.image;
      // Varsayılan görsel
      return Recete3 as unknown as string;
    };
    const run = async () => {
      try {
        const res = await fetch(toUrl('/api/tibbi-birimler'));
        if (!res.ok) throw new Error('fetch_failed');
        const data = await res.json();
        const list = Array.isArray(data) ? data : [];
        const mapped = list.map((it: any) => ({
          title: (it.title || '').trim(),
          paragraphs: Array.isArray(it.paragraphs) ? it.paragraphs.map((p: any) => (p || '').trim()).filter(Boolean) : [],
          image: chooseImage(it.title || ''),
        }));
        if (!cancelled && mapped.length) setDepartments(mapped);
      } catch {
        // defaultları koru
      }
    };
    run();
    return () => { cancelled = true; };
  }, []);

  // Fetch AboutHero content for Tibbi Birimler
  React.useEffect(() => {
    let cancelled = false;
    const run = async () => {
      try {
        const res = await fetch(toUrl('/api/page-hero/tibbi-birimler'));
        if (!res.ok) throw new Error('fetch_failed');
        const data = await res.json();
        const obj = Array.isArray(data) ? (data[0] || {}) : (data || {});
        if (cancelled) return;
        setHeroKicker((obj.kicker || '').trim());
        setHeroTitle((obj.title || '').trim());
        setHeroDesc((obj.description || '').trim());
      } catch {
        // keep defaults
      }
    };
    run();
    return () => { cancelled = true; };
  }, []);
  return (
    <>
      {/* <AboutHero
        image={Recete3}
        kicker=""
        title="Tıbbi Birimler"
        description="Hastanemiz, geniş bir yelpazede tıbbi birimler sunar. Dahiliye, cerrahi, pediatri, kadın doğum, kardiyoloji, göz, kulak-burun-boğaz, radyoloji, onkoloji ve daha fazlasında uzmanlaşmış ekiplerimiz, hastalarımıza en iyi sağlık hizmetini sunmayı taahhüt eder. Gelişmiş teknoloji ve deneyimli doktorlarımızla hastalarımızın ihtiyaçlarını karşılarız."
        overlayColor="#2cadd2"
        overlayOpacity={0.72}
        accentColor="#e30613"
        textColor="#2b2b2b"
        focus="center center"
        align="center"
        desktopHeight={460}
        tabletHeight={380}
        mobileHeight={320}
      /> */}

      <AboutHero
        image={Recete3}
        kicker={heroKicker || DEFAULT_HERO.kicker}
        title={heroTitle || DEFAULT_HERO.title}
        description={heroDesc || DEFAULT_HERO.description}
        overlayColor="#2cadd2"
        overlayOpacity={0.72}
        accentColor="#e30613"
        textColor="#2b2b2b"
        focus="center center"
        align="center"
        desktopHeight={460}
        tabletHeight={380}
        mobileHeight={320}
      />

      <DepartmentShowcase items={departments} maxWidth={1200} />
    </>
  );
};

export default TibbiBirimlerPage;
